export default "__VITE_ASSET__CxD_KGDz__"